// export const API_ENDPOINT = window.location.protocol + '//' + window.location.hostname + ':15000/';
export const API_ENDPOINT = '/api/';
